/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Teams_Type_To_NarrowInputs */

const cs_settings_teams_type_to_narrow = /** @type {(inputs: Settings_Teams_Type_To_NarrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pište dál, zbývá ${i?.count}`)
};

const en_settings_teams_type_to_narrow = /** @type {(inputs: Settings_Teams_Type_To_NarrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type to narrow ${i?.count} more`)
};

/**
* | output |
* | --- |
* | "Type to narrow {count} more" |
*
* @param {Settings_Teams_Type_To_NarrowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_type_to_narrow = /** @type {((inputs: Settings_Teams_Type_To_NarrowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Type_To_NarrowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_type_to_narrow(inputs)
	return cs_settings_teams_type_to_narrow(inputs)
});